import React from "react";
import { Link } from "react-router-dom";
import { Flex, Box } from "grid-styled";
import { Helmet } from "react-helmet";
import { PageContainer } from "../Grid";
import { H2, SmallBody } from "../TextStyles";
import { LargeButton } from "../Button";
import homeBg from "./biofit-builder-home-chairs.png";
import SVGIcon from "../SVGIcon";

const Home = () => (
  <PageContainer>
    <Helmet>
      <title>My Chair</title>
    </Helmet>

    <Flex flexWrap="wrap">
      <Box width={[1, 1, 1 / 2]}>
        <H2 as="h1">Discover the comfort and quality of BioFit.</H2>
        <Box mb="2rem">
          Get fast, easy access to all the information you need on any chair in the extensive line
          of BioFit furnishings. Or, design your ideal seating option, built to your exact
          specifications.
        </Box>
        <Link to="/find-chair">
          <LargeButton>
            Find My Chair <SVGIcon icon="search" />
          </LargeButton>
        </Link>
        <SmallBody mt="1rem" mb="1rem">
          Get assembly and operational videos, plus up-to-date warranty information.
        </SmallBody>
        <Link to="/market">
          <LargeButton>
            Build A Chair <SVGIcon icon="gear" />
          </LargeButton>
        </Link>
        <SmallBody mt="1rem" mb="1rem">
          BioFit can help you customize seating that’s just right for your specifications.
        </SmallBody>
      </Box>
      <Box width={[1, 1, 1 / 2]}>
        <img src={homeBg} alt="BioFit Builder" />
      </Box>
    </Flex>
  </PageContainer>
);

export default Home;
